
import './DashboardpagesCss/BookHomeCollection.css';
import AppointmentSection from "../HomeCollectionPageElements/AppointmentSection";
import { FaLocationCrosshairs } from "react-icons/fa6";
import { useState } from "react";

const BookHomeCollection = () => {
    const [formData, setFormData] = useState({
        mobile: "",
        firstname: "",
        lastname: "",
        email: "",
        dob: "",
        gender: "male",
        address: "",
        landmark: "",
        state: "",
        city: "",
        pincode: "",
        preferredDate: "",
        rawTime: "",
        preferredTime: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "rawTime") {
            const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

            if (timeRegex.test(value)) {
                const [hours, minutes] = value.split(":").map(Number);
                const start = new Date();
                start.setHours(hours, minutes, 0);

                const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);

                const formatTime = (date) =>
                    date.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                    });

                const slot = `${formatTime(start)} - ${formatTime(end)}`;

                setFormData((prev) => ({
                    ...prev,
                    rawTime: value,
                    preferredTime: slot,
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    rawTime: value,
                    preferredTime: "",
                }));
            }
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", formData);
    };

    const handleReset = () => {
        setFormData({
            mobile: "",
            firstname: "",
            lastname:"",
            email: "",
            dob: "",
            gender: "male",
            address: "",
            landmark: "",
            state: "",
            city: "",
            pincode: "",
            preferredDate: "",
            rawTime: "",
            preferredTime: "",
        });
    };

    return (
        <div className="container">
            {/* <div className="profile-header">
                <h2 className="appointmentHeading">Home Collection</h2>
            </div> */}
            <div className="profile-header">
                <h2>Home Collection</h2>
            </div>
            <div className="profile-card">
                <div className="bhc-form-wrapper">
                    <h2 className="bhc-form-heading">Home Collection Booking</h2>
                    <form className="bhc-form" onSubmit={handleSubmit}>
                        <div className="bhc-input-group half">
                            <label htmlFor="mobile" className="bhc-label">
                                Enter Your Mobile Number
                            </label>
                            <input
                                type="text"
                                id="mobile"
                                name="mobile"
                                placeholder="Mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="bhc-row">
                            <div className="bhc-input-group half">
                                <label htmlFor="firstname" className="bhc-label">
                                    Enter First Name
                                </label>
                                <input
                                    type="text"
                                    id="firstname"
                                    name="firstname"
                                    placeholder="First Name"
                                    value={formData.firstname}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="bhc-input-group half">
                                <label htmlFor="lastname" className="bhc-label">
                                    Enter Last Name
                                </label>
                                <input
                                    type="text"
                                    id="lastname"
                                    name="lastname"
                                    placeholder="Last Name"
                                    value={formData.firstname}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="bhc-input-group">
                                <label className="bhc-label">Gender</label>
                                <div className="bhc-gender-options">
                                    {["male", "female", "other"].map((g) => (
                                        <label key={g}>
                                            <input
                                                type="radio"
                                                name="gender"
                                                value={g}
                                                checked={formData.gender === g}
                                                onChange={handleChange}
                                            />{" "}
                                            {g.charAt(0).toUpperCase() + g.slice(1)}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="bhc-row">
                            <div className="bhc-input-group">
                                <label htmlFor="dob" className="bhc-label">
                                    Date of Birth
                                </label>
                                <input
                                    type="date"
                                    id="dob"
                                    name="dob"
                                    value={formData.dob}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="bhc-input-group">
                                <label htmlFor="email" className="bhc-label">
                                    Enter Email
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="bhc-row">
                            <div className="bhc-input-group half">
                                <label htmlFor="address" className="bhc-label">
                                    Address
                                </label>
                                <input
                                    type="text"
                                    id="address"
                                    name="address"
                                    placeholder="Address"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="bhc-input-group">
                                <label htmlFor="landmark" className="bhc-label">
                                    Landmark
                                </label>
                                <input
                                    type="text"
                                    id="landmark"
                                    name="landmark"
                                    placeholder="Landmark"
                                    value={formData.landmark}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="bhc-row">
                            <div className="bhc-input-group">
                                <label htmlFor="state" className="bhc-label">
                                    State
                                </label>
                                <input
                                    type="text"
                                    id="state"
                                    name="state"
                                    placeholder="State"
                                    value={formData.state}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="bhc-input-group">
                                <label htmlFor="city" className="bhc-label">
                                    City
                                </label>
                                <input
                                    type="text"
                                    id="city"
                                    name="city"
                                    placeholder="City"
                                    value={formData.city}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="bhc-input-group">
                                <label htmlFor="pincode" className="bhc-label">
                                    Pin Code
                                </label>
                                <input
                                    type="text"
                                    id="pincode"
                                    name="pincode"
                                    placeholder="Pin Code"
                                    value={formData.pincode}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="btnLocation halfSection">
                            <button className="rbdButton" type="button">
                                <span className="btn-text"><FaLocationCrosshairs /> Use current location</span>
                            </button>
                            <button className="rbdButton" type="button">
                                <span className="btn-text">Upload Prescription</span>
                            </button>
                            <button className="rbdButton" type="button">
                                <span className="btn-text"> Choose Referral Doctor</span>
                            </button>
                        </div>
                        <div className="bhc-row">
                            <div className="bhc-input-group">
                                <label htmlFor="preferredDate" className="bhc-label">
                                    Select Date
                                </label>
                                <input
                                    type="date"
                                    id="preferredDate"
                                    name="preferredDate"
                                    value={formData.preferredDate}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="bhc-input-group">
                                <label htmlFor="rawTime" className="bhc-label">
                                    Select Time
                                </label>
                                <input
                                    type="time"
                                    id="rawTime"
                                    name="rawTime"
                                    value={formData.rawTime}
                                    onChange={handleChange}
                                />
                                {formData.preferredTime && (
                                    <div className="bhc-time-slot">
                                        Slot: {formData.preferredTime}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="bhc-footer-buttons">
                            <button className="rbdButton" type="submit">
                                <span className="btn-text">Submit</span>
                            </button>
                            <button className="rbdButton reset-Btn" type="button" onClick={handleReset}>
                                <span className="btn-text">Reset</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BookHomeCollection;
